import React from "react";
import Styles from "./style.module.scss";
import Img1 from "@Assets/Images/login-step.png";
import Img2 from "@Assets/Images/marketing-announcement.png";
import Img3 from "@Assets/Images/applicant.png";

const steps = [
  {
    title: "Daftar Gratis",
    description: "Mulai lah dengan membuat akun Anda secara gratis",
    img: Img1,
  },
  {
    title: "Pasang Lowongan Kerja",
    description: "Iklan kan lowongan pekerjaan Anda dengan mudah",
    img: Img2,
  },
  {
    title: "Terima Lamaran",
    description: "Proses lamaran kandidat yang masuk",
    img: Img3,
  },
];

export default function StepsJobPosting() {
  return (
    <section className={Styles.wrapStepsJobPosting}>
      <h1>Pasang Loker Mudah</h1>

      <div className={Styles.decorationCircle}></div>

      <div className={Styles.wrapperCards}>
        {steps.map((el, idx) => (
          <div className={Styles.card} key={idx}>
            <div>
              <img src={el.img} alt={el.title} />
            </div>
            <h2>{el.title}</h2>
            <p>{el.description}</p>
            <div className={Styles.number}>
              <span>{idx + 1}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
